/* Native <details> menu: one delegated listener survives Shopify editor section reloads. */
(() => {
  if (window.__tupGlobalMenuBound) return;
  window.__tupGlobalMenuBound = true;

  document.addEventListener('click', (event) => {
    document.querySelectorAll('details[data-tup-explore][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[data-tup-explore][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();
